declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

export function trackPageview(path: string) {
  if (typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
    page_title: document.title,
  });
}
